<template>
    <section class="row section-global hassle-free">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1 class="text-upper">{{ this.sectionData.title }}</h1>
                    <h3 class="m-t service-description">
                        {{ sectionDescription.description }}
                    </h3>
                    <ul class="m-t service-description">
                        <li v-for="(item, index) in sectionDescription.descriptionList" :key="index">
                            {{ item }}
                        </li>
                    </ul>
                    <a @click="$emit('scroll-to', sectionData.landing_page_buttons[0].url)" href="#" class="btn btn-green m-y-md">{{ sectionData.landing_page_buttons[0].text }}</a>
                </div>
            </div>
        </div>
        <img class="bg-case" :src="sectionData.logo_url">
    </section>
</template>

<script>
import { stripTags } from "../../../util/filters";
export default {
    name: "HassleFreeSection",
    props: {
        sectionData: {
            type: Object,
            required: true
        }
    },
    computed: {
        sectionDescription() {
            const sectionDescription = stripTags(this.sectionData.body).split("\n").filter(Boolean).map(item => {
                if (item.startsWith("* ")) {
                    item = item.replace("* ", "");
                }

                return item;
            });

            const description = sectionDescription.splice(0, 1);

            return {
                description: description[0],
                descriptionList: sectionDescription
            }
        }
    }
}
</script>

<style lang="scss">
.pc-rental {

    .hassle-free {
        background-color: #a5a5a5;
        position: relative;
        overflow: hidden;

        h1 {
            font-size: 36px;
        }

        h1, h3, ul li {
            color: white;
        }

        .service-description {
            font-size: 20px;
        }

        ul {
            padding-left: 20px;
            list-style-type: initial;
        }

        .bg-case {
            position: absolute;
            right: -100px;
            top: -130px;
            height: 830px;
        }

        @media screen and (max-width: 1200px) {
            h1 {
                margin-top: 70px;
            }

            .bg-case {
                right: -160px;
                top: -90px;
                height: 700px;
            }
        }

        @media screen and (max-width: 992px) {
            padding: 10px;
            padding-bottom: 0;

            .bg-case {
                display: none;
            }

            .btn {
                width: 100%;
                margin-bottom: 50px !important;
            }
        }
    }

}

</style>
